module.exports = __webpack_public_path__ + "static/media/komponenty_termometr.29979b30.svg";